import {
	BreadcrumbsStylesListItems,
	breadcrumbsBaseStyle,
	breadcrumbsSeparatorStyle,
	BreadcrumbsStylesList,
} from './styles';
import { ISmartProps } from './types';
import { getBaseCustomProps } from '../../Utilities/types/SharedProps';
import * as meta from '../../meta-data.json';

export const overrides = (props: ISmartProps) => {
	const { collapse, ...rest } = props;
	return {
		ListItem: {
			style: ({ $theme }: any) => {
				return { ...BreadcrumbsStylesListItems($theme) };
			},
		},
		List: {
			style: ({ $theme }: any) => {
				return { ...BreadcrumbsStylesList($theme) };
			},
		},
		Root: {
			style: ({ $theme }: any) => {
				return { ...breadcrumbsBaseStyle($theme) };
			},
			props: {
				...rest,
				...getBaseCustomProps(props),
				'data-epo': `epo-breadcrumbs-${meta.version}`,
				part: `epo-breadcrumbs-${meta.version}`,
			},
		},
		Separator: {
			style: ({ $theme }: any) => {
				return { ...breadcrumbsSeparatorStyle($theme) };
			},
		},
		Icon: {
			props: {
				overrides: {
					Svg: {
						props: {
							title: undefined,
							'aria-hidden': true,
						},
						style: ({ $theme }: any) => ({
							verticalAlign: 'text-top',
							pointerEvents: 'none',
						}),
					},
				},
			},
		},
	};
};
